import { RegistrationFormData } from './registrationFormData';
import { ActionType, RegistrationFormActions } from './actions';
import { SessionStorageKey, sessionStorageService } from '../../utils/SessionStorageService';

export const reducer = (state: RegistrationFormData, action: RegistrationFormActions): RegistrationFormData => {
  switch (action.type) {
    case ActionType.UpdateFormData: {
      const data = {
        ...state,
        ...action.payload,
      };
      sessionStorageService.set(SessionStorageKey.RegisterData, JSON.stringify(data));
      return data;
    }
    case ActionType.ClearForm:
      sessionStorageService.remove(SessionStorageKey.RegisterData);
      return {};
    default:
      return state;
  }
};
